import { Card, CardContent, CardHeader } from '@ui/card.tsx';
import { Skeleton } from '@ui/skeleton.tsx';

export function CompanySkeleton() {
  return (
    <div className="space-y-5">
      {/* Header — aligné sur CompanyProfileHeader */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex gap-5 items-center">
          <Skeleton className="rounded-full size-12 shrink-0" />
          <div className="flex-1 space-y-2 min-w-0">
            <div className="flex flex-wrap gap-2 items-center">
              <Skeleton className="w-48 max-w-full h-9" />
              <Skeleton className="w-20 h-6 rounded-full" />
              <Skeleton className="w-24 h-6 rounded-full" />
            </div>
            <div className="flex flex-col gap-1 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-4 sm:gap-y-1">
              <Skeleton className="w-56 h-4" />
              <Skeleton className="w-40 h-4" />
              <Skeleton className="w-44 h-4" />
            </div>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <Skeleton className="w-24 h-9 rounded-md" />
          <Skeleton className="w-36 h-9 rounded-md" />
          <Skeleton className="w-32 h-9 rounded-md" />
        </div>
      </div>

      {/* Grille — alignée sur CompanyDetailsGrid */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:items-stretch">
        <Card className="w-full lg:col-span-2">
          <CardHeader className="p-10 pb-4">
            <div className="flex justify-between items-center">
              <Skeleton className="w-48 h-8" />
              <Skeleton className="w-24 h-9" />
            </div>
          </CardHeader>
          <CardContent className="p-10 pt-0 space-y-8">
            <div className="space-y-2">
              <Skeleton className="w-40 h-5" />
              <div className="h-px bg-border" />
              <div className="grid grid-cols-[160px_1fr] gap-y-3">
                {[...Array(6)].map((_, i) => (
                  <div key={i} className="contents">
                    <Skeleton className="w-24 h-4" />
                    <Skeleton className="w-full max-w-md h-4" />
                  </div>
                ))}
              </div>
            </div>
            <div className="space-y-2">
              <Skeleton className="w-44 h-5" />
              <div className="h-px bg-border" />
              <div className="grid grid-cols-[160px_1fr] gap-y-3">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="contents">
                    <Skeleton className="w-28 h-4" />
                    <Skeleton className="w-full max-w-md h-4" />
                  </div>
                ))}
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="flex flex-col lg:col-span-1">
          <CardHeader className="p-6 pb-3">
            <Skeleton className="w-36 h-7" />
          </CardHeader>
          <CardContent className="flex flex-col flex-1 p-6 pt-0 space-y-6">
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <Skeleton className="w-36 h-5" />
                <Skeleton className="w-44 h-8" />
              </div>
              <div className="space-y-2">
                <Skeleton className="w-full h-12 rounded-md" />
                <Skeleton className="w-full h-12 rounded-md" />
              </div>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <Skeleton className="w-40 h-5" />
                <Skeleton className="w-32 h-8" />
              </div>
              <Skeleton className="w-full h-12 rounded-md" />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
